import styled from 'styled-components'
import { colors } from '../../../../../../enums'
import { FONT } from '../../../../../../utils'
import { TImage } from '../../../../types'

export const Container = styled.div`
   display: grid;
   margin-top: 30px;
   margin-left: 44px;
   margin-bottom: 30px;
   grid-template-columns: 2fr 1fr;
   grid-column-gap: 60px;
`

export const Line = styled.div`
   border-bottom: 1px solid #f4f4f4;
   margin-bottom: 32px;
`

export const Text = styled.p`
   margin-left: 30px;
   margin-bottom: 30px;
   ${FONT({ size: '16px', weight: '500' })};
`

export const PhotoText = styled.p`
   ${FONT({ size: '16px', weight: '500' })};
`

export const EditImage = styled.div<TImage>`
   display: inline-block;
   background-image: ${({ src }) => `url(${src})`};
   background-repeat: no-repeat;
   background-size: contain;
   height: 119px;
   width: 119px;
`

export const RelatedProductsContainer = styled.div`
   display: flex;
   flex-wrap: nowrap;
   width: 100%;
   overflow-x: auto;
   gap: 17px;
   padding-bottom: 15px;
`

export const RelatedProductWrapper = styled.div`
   display: flex;
   flex-direction: column;
   position: relative;
   font-size: 12px;
   border: 1px solid ${colors.table_grey};
   border-radius: 6px;
   padding: 12px 8px;
   min-width: 138px;
   width: 138px;
   height: 190px;
   .product-delete {
      width: 12px;
      height: 12px;
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
   }
   .product-img {
      width: 46px;
      height: 46px;
      object-fit: contain;
      align-self: center;
   }
   .product-code {
      font-weight: 500;
      padding: 12px 0 6px;
   }
   .product-name {
      line-height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
   }
   .product-price {
      padding-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 5px;
      &__old {
         color: ${colors.grey};
         text-decoration: line-through;
      }
      &__new {
      }
   }
`
